import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import glenLoadingBg from '../../assets/images/loading/glen-loading-bg.webp';
import glenLogo from '../../assets/images/loading/glen-logo.png';
import './style.scss';

const Gallery360 = () => {
  const [activeTab, setActiveTab] = useState('vr360');
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 1024 : false
  );
  const [isMenuHidden, setIsMenuHidden] = useState(false);

  const imageFiles = [
    { file: 'BASEMENT.webp', title: 'Basement' },
    { file: 'LEVEL 1 TOP.webp', title: '1' },
    { file: 'LEVEL 2 TOP.webp', title: '2' },
    { file: 'LEVEL 3 TOP.webp', title: '3' },
    { file: 'LEVEL 4 TOP.webp', title: '4' },
    { file: 'LEVEL 5 TOP.webp', title: '5' },
  ];

  const basePublicPath = `${process.env.PUBLIC_URL}/assets/${
    isMobile ? 'gallery-360-mobile' : 'gallery-360'
  }/`;

  const galleryImages = imageFiles.map((item) => ({
    src: `${basePublicPath}${encodeURIComponent(item.file)}`,
    title: item.title,
  }));

  // Preload images early so first open feels instant
  React.useEffect(() => {
    const preloadLinks = [];
    galleryImages.forEach((img, idx) => {
      const image = new Image();
      image.decoding = 'async';
      image.src = img.src;
      if (idx < 2 && typeof document !== 'undefined') {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = img.src;
        document.head.appendChild(link);
        preloadLinks.push(link);
      }
    });
    return () => {
      preloadLinks.forEach((l) => l.parentNode && l.parentNode.removeChild(l));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basePublicPath]);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    lazyLoad: 'anticipated',
    waitForAnimate: true,
    afterChange: (index) => setCurrentSlide(index),
  };

  React.useEffect(() => {
    const onResize = () => {
      const nextIsMobile = window.innerWidth < 1024;
      setIsMobile(nextIsMobile);
    };
    window.addEventListener('resize', onResize);
    const onSvgBtn = () => setIsMenuHidden((prev) => !prev);
    window.addEventListener('svgblackbtn:click', onSvgBtn);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('svgblackbtn:click', onSvgBtn);
    };
  }, []);

  const handleClickVR = () => {
    setActiveTab('vr360');
    setIsGalleryOpen(false);
  };

  const handleClickGallery = () => {
    setActiveTab('gallery');
    setIsGalleryOpen(true);
  };

  return (
    <>
      <div className={`gallery360${isMenuHidden ? ' menu-hidden' : ''}`}>
        <div
          className="menu"
          style={{ display: isMenuHidden ? 'none' : undefined }}
        >
          <div
            className={`gallery-btn${activeTab === 'gallery' ? ' active' : ''}`}
            onClick={handleClickGallery}
          >
            Gallery
          </div>
          <div
            className={`vr360-btn${activeTab === 'vr360' ? ' active' : ''}`}
            onClick={handleClickVR}
          >
            VR360
          </div>
        </div>
        {isGalleryOpen && (
          <div
            className="gallery-overlay"
            style={{ backgroundImage: `url(${glenLoadingBg})` }}
          >
            <div className="overlay-content">
              <button
                type="button"
                className="gallery-close"
                aria-label="Close gallery"
                onClick={handleClickVR}
              >
                ×
              </button>
              <div className="overlay-logo">
                <img src={glenLogo} alt="The Glen" />
              </div>
              <div className="gallery-tabs">
                {galleryImages.map((image, index) => (
                  <button
                    key={index}
                    className={`tab-item${
                      currentSlide === index ? ' active' : ''
                    }`}
                    onClick={() =>
                      sliderRef.current && sliderRef.current.slickGoTo(index)
                    }
                  >
                    {image.title}
                  </button>
                ))}
              </div>
              <Slider
                ref={sliderRef}
                {...sliderSettings}
                className="gallery-slider"
              >
                {galleryImages.map((image, index) => (
                  <div key={index} className="slide-item">
                    <img src={image.src} alt={image.title} loading="lazy" />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Gallery360;
